import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { parse } from '../../util/urlHelpers';
import { CREDITS_PACKAGE_1, CREDITS_PACKAGE_2, CREDITS_PACKAGE_3 } from '../../credits-config';
import { SEARCH_PARAM_PACKAGE_KEY, SEARCH_PARAM_PACKAGE_ADD_CREDITS } from './configs';
/**
 * e.g.
 * ?pckg=p_c_30
 * ?addCredits=true
 */
export const useInitialPackageFromSearchParam = ({ setModalOpen }) => {
    const history = useHistory();
    const [selectedPackage, setSelectedPackage] = useState(CREDITS_PACKAGE_1);

    const searchParamsParsed = parse(history.location.search);
    const packageFromSearchParamsSelected = searchParamsParsed[SEARCH_PARAM_PACKAGE_KEY];
    const addCreditsSearchParam = searchParamsParsed[SEARCH_PARAM_PACKAGE_ADD_CREDITS];

    useEffect(() => {
        if (!packageFromSearchParamsSelected && !addCreditsSearchParam) return;

        if (addCreditsSearchParam) {
            setSelectedPackage('p_c_30');
            setModalOpen(true);
            return;
        }

        if (
            packageFromSearchParamsSelected !== CREDITS_PACKAGE_1 &&
            packageFromSearchParamsSelected !== CREDITS_PACKAGE_2 &&
            packageFromSearchParamsSelected !== CREDITS_PACKAGE_3
        ) {
            return;
        }

        setSelectedPackage(packageFromSearchParamsSelected);
        setModalOpen(true);
    }, [packageFromSearchParamsSelected, addCreditsSearchParam]);

    return selectedPackage;
};
